import { makeStyles } from 'makeStyles';
import { BORDERS_GREY, BOX_SHADOW, WHITE } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  root: {
    border: BORDERS_GREY,
    padding: theme.spacing(3),
    overflow: 'auto',
    borderRadius: 4,
    backgroundColor: WHITE,
    boxShadow: `0 4px 20px 0 ${BOX_SHADOW}`,
  },
}));
